<template>
	<div class="minibasket" v-bind:class="{'animateOut': animateOut, '-hide' : hide }">
		<div class="minibasket__header">{{variantAddedToBasketLabel}}</div>
		<div class="minibasket__items"  v-if="content != null">
			<div class="minibasket__image__wrapper">
				<img :src="productImageUrl" :alt="productName" class="minibasket__image" />
			</div>

			<div class="minibasket__name"><div class="minibasket__name-product">{{productName}}</div></div>
			<div class="minibasket__qnt">{{content.quantity}} {{variantAddedToBasketItemLabel}}</div>
		</div>
		<a :href="basketUrl" class="minibasket__button e-button__right e-button--small" data-basket-nav-src="mini basket">
			<span>{{goToBasketLabel}}</span>
		</a>
	</div>
</template>
<script>
	export default {
		props: [
			'variantAddedToBasketLabel', 'variantAddedToBasketItemLabel', 'goToBasketLabel', 'basketUrl', 'productName', 'productImageUrl'
		],
		data() {
			return {
				hide: true,
				animateOut: false,
				content: null
			}
		},
		mounted() {
			this.$eventBus.$on('itemsAddedToTheBasket', (result) => {
				this.hide = false;
				this.content = result;
				setTimeout(() => {
					this.animateOut = true;
				}, 2500);
				setTimeout(() => {
					this.hide = true;
					this.animateOut = false;
				}, 3000);
			});
		}
	}
</script>
